<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a :href=route_back>Список лицензий</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">Добавить лицензию</li>
        </ol>
    </nav>

    <div class="col-12">
        <div class="form-row mb-4">
            <div class="col-md-6">
                <label class="form-label">Устройство</label>
                <div class="app-dropdown">
                    <div @click="openDropDown()" class="manager">
                        <div class="button">
                            <div v-if="forms.searchingDevices.selectedItem">
                                {{ forms.searchingDevices.selectedItem.pharmacy_number }},
                                {{ forms.searchingDevices.selectedItem.address }},
                                {{ forms.searchingDevices.selectedItem.type }} {{ forms.searchingDevices.selectedItem.item }}
                            </div>
                        </div>
                    </div>
                    <div
                        v-bind:class="{
                            hidden: !forms.searchingDevices.openDropDown,
                            open: forms.searchingDevices.openDropDown
                        }"
                        class="content"
                    >
                        <div class="items-block">

                            <div class="items">
                                <div class="searching-block">
                                    <input
                                        @keyup.enter="onSearchDevices()"
                                        @keyup.delete="onCancelSearchDevices()"
                                        v-model="forms.searchingDevices.searchingControl"
                                        type="text"
                                        class="form-control"
                                        placeholder="Поиск"
                                    >
                                </div>
                                <div
                                    class="item"
                                    @click="selectDevice(device)"
                                    v-for="device in forms.searchingDevices.devices"
                                    :value="device"
                                >
                                    {{ device.pharmacy_number }},
                                    {{ device.address }},
                                    {{ device.type }} {{ device.item }}
                                </div>
                            </div>

                        </div>
                        <div
                            @click="closeDropDown()"
                            v-bind:class="{
                                hidden: !forms.searchingDevices.openDropDown,
                                open: forms.searchingDevices.openDropDown
                            }"
                            class="shade"
                        >
                        </div>
                    </div>
                </div>

                <div class="p-1">
                    <label class="form-label mt-3">Клиент</label>
                    <div v-if="forms.searchingDevices.selectedItem">
                        {{ forms.searchingDevices.selectedItem.client_name }}
                    </div>
                    <label class="form-label mt-3">Брэнд</label>
                    <div v-if="forms.searchingDevices.selectedItem">
                        {{ forms.searchingDevices.selectedItem.brand_name }}
                    </div>
                    <label class="form-label mt-3">Организация</label>
                    <div v-if="forms.searchingDevices.selectedItem">
                        {{ forms.searchingDevices.selectedItem.org_name }}
                    </div>
                </div>
            </div>
        </div>

        <div class="form-row mb-4">
            <div class="col-md-4">
                <label class="form-label">Договор</label>
                <div class="app-dropdown">
                    <div @click="openDropDownSearchingContracts()" class="manager">
                        <div class="button">
                            <div v-if="forms.searchingContracts.selectedItem">
                                {{ forms.searchingContracts.selectedItem.contract_name }}
                                № {{ forms.searchingContracts.selectedItem.contract_number }}
                            </div>
                        </div>
                    </div>
                    <div
                        v-bind:class="{
                            hidden: !forms.searchingContracts.openDropDown,
                            open: forms.searchingContracts.openDropDown
                        }"
                        class="content"
                    >
                        <div class="items-block">

                            <div class="items">
                                <div class="searching-block">
                                    <input
                                        @keyup.enter="onSearchContracts()"
                                        @keyup.delete="onCancelSearchContracts()"
                                        v-model="forms.searchingContracts.searchingControl"
                                        type="text"
                                        class="form-control"
                                        placeholder="Поиск"
                                    >
                                </div>
                                <div
                                    class="item"
                                    @click="selectContracts(item)"
                                    v-for="item in forms.searchingContracts.items"
                                    :value="item"
                                >
                                    {{ item.contract_name }} № {{ item.contract_number }}
                                </div>
                            </div>
                        </div>

                        <div
                            @click="closeDropDownSearchingContracts()"
                            v-bind:class="{
                                hidden: !forms.searchingContracts.openDropDown,
                                open: forms.searchingContracts.openDropDown
                            }"
                            class="shade">
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="form-row mb-4">
            <div class="col-md-4">
                <label for="license-pay">Стоимость в месяц</label>
                <input
                    type="text"
                    class="form-control"
                    id="license-pay"
                    v-model="forms.searchingDevices.payPerMounth"
                    placeholder="Введите стоимость лицензии">
            </div>
        </div>

        <div class="form-row mb-4">
            <div class="col-md-4">
                <label for="device-expires_at">Период действия</label>
                <select @change="onChangeValidity($event)" class="form-select" v-model="forms.validity.selected">
                    <option value="1">
                        Cрочная – на год
                    </option>
                    <option value="2">
                        Бессрочная
                    </option>
                    <option value="3">
                        Указать в ручную
                    </option>
                </select>

                <div v-if="forms.validity.selected == 3"  class="mt-3 d-flex align-items-center justifully-content-center">
                    <input
                        type="date"
                        class="form-control w-75"
                        id="created-license"
                        v-model="forms.validity.createdLicense"
                        @change="onChangeCreatedLicense($event)">
                    <input
                        type="date"
                        class="form-control w-75 ms-1"
                        id="expires-at"
                        v-model="forms.validity.expiresAt"
                        @change="onChangeExp($event)">
                </div>

                <div v-if="forms.validity.selected == 1"  class="mt-3 d-flex align-items-center justifully-content-center">
                    <input
                        type="date"
                        class="form-control w-75"
                        id="created-license"
                        v-model="forms.validity.createdLicense"
                        @change="onChangeCreatedLicense($event)">
                    <input
                        type="date"
                        class="form-control w-75 ms-1"
                        id="expires-at"
                        v-model="forms.validity.expiresAt"
                        disabled>
                </div>
            </div>
        </div>

        <div class="form-row mb-4">
            <div class="col-md-4">
                <label for="device-expires_at">Статус оплаты</label>
                <select @change="onChangeStatusPayment($event)" class="form-select" v-model="forms.statusPay.selected">
                    <option value="1">
                        Не оплачено
                    </option>
                    <option value="2">
                        Выставлен счет
                    </option>
                    <option value="3">
                        Оплачено
                    </option>
                </select>
            </div>
        </div>
    </div>

    <div class="d-flex w-50 align-items-center justify-content-start ms-1">
        <button class="btn btn-lg btn-primary me-3" v-on:click="onCreateLicense()">
            Добавить
        </button>
        <a class="btn btn-lg btn-outline-dark" :href="route_back">Отменить</a>
    </div>

    <div class="modal-mask" v-if="modals.infoForCreatedLicense.isOpen">
        <div class="modal-wrapper">
            <div class="modal-container">
                <div class="modal-header">
                    <h5 class="modal-title color-accent">Ключ лицензии</h5>
                </div>
                <div class="modal-body">
                    <div class="fsz-20px fw-500" ref="copyTextEl">{{ modals.infoForCreatedLicense.uuid }}</div>
                </div>
                <div class="modal-footer">
                    <button v-on:click="closeModal()"
                            class="btn btn-md btn-success m-1">
                        Закрыть
                    </button>
                    <button v-if="modals.infoForCreatedLicense.isNavigator"
                            v-on:click="copyUuid()"
                            class="btn btn-md btn-primary"
                            type="button">
                        Копировать
                    </button>
                </div>
            </div>
        </div>
    </div>

    <Alert />
</template>

<script>
import Alert from '../../../alerts/Alert.vue';
import { mapMutations } from 'vuex/dist/vuex.cjs.js';

export default {
    name: "LicenseCreateComponent",
    components: { Alert },
    props: {
        route_back: String,
        route_devices_search: String,
        route_create: String
    },
    watch: {
    },
    data: function () {
        return {
            license: {
                device_id: {
                    value: null,
                    desc: "Вы не выбрали устройство",
                },
                type: {
                    value: null,
                    desc: "Вы не выбрали период действия",
                },
                expires_at: {
                    value: null,
                    desc: "Вы не выбрали период действия",
                },
                status_payment: {
                    value: null,
                    desc: "Вы не выбрали статус платежа",
                },
                pay_per_month: {
                    value: null,
                    desc: "Вы не ввели стоимость лицензии",
                },
                contract_id: {
                    value: null,
                    desc: "Вы не выбрали договор",
                },
                created_at: {
                    value: null,
                    desc: "Вы не выбрали период действия",
                }
            },
            forms: {
                searchingDevices: {
                    openDropDown: false,
                    devices: [],
                    selectedItem: null,
                    searchingControl: null,
                    payPerMounth: null
                },
                validity: {
                    selected: null,
                    createdLicense: null,
                    expiresAt: null
                },
                statusPay: {
                    selected: null
                },
                searchingContracts: {
                    openDropDown: false,
                    items: [],
                    selectedItem: null,
                    searchingControl: null,
                    payPerMounth: null
                }
            },
            modals: {
                infoForCreatedLicense: {
                    uuid: null,
                    isOpen: false,
                    isNavigator: navigator && navigator.clipboard && navigator.clipboard.writeText
                }
            },
        }
    },
    methods: {
        ...mapMutations('alerts', ['addAlert']),
        licenseFish: function () {
            return {
                device_id: {
                    value: null,
                    desc: "Вы не выбрали устройство",
                },
                type: {
                    value: null,
                    desc: "Вы не выбрали период действия",
                },
                expires_at: {
                    value: null,
                    desc: "Вы не выбрали период действия",
                },
                status_payment: {
                    value: null,
                    desc: "Вы не выбрали статус платежа",
                },
                pay_per_month: {
                    value: null,
                    desc: "Вы не ввели стоимость лицензии",
                },
                contract_id: {
                    value: null,
                    desc: "Вы не выбрали договор",
                },
                created_at: {
                    value: null,
                    desc: "Вы не выбрали период действия",
                }
            };
        },
        onChangeStatusPayment: function(e) {
            this.license.status_payment.value = e.target.value;
        },
        onChangeCreatedLicense: function(e) {
            const selectedCreatedDate = e.target.value;

            if (!selectedCreatedDate) {
                this.forms.validity.expiresAt = null;
                this.forms.createdLicense = null;

                this.license.expires_at.value = null;
                this.license.created_at.value = null;
            }

            if (selectedCreatedDate) {
                if (this.forms.validity.selected == 1) {
                    const date = new Date(selectedCreatedDate);

                    this.forms.validity.expiresAt = this.parseDate(date, 1, 1, 0);

                    this.license.expires_at.value = this.forms.validity.expiresAt;
                    this.license.created_at.value = selectedCreatedDate;
                }

                if (this.forms.validity.selected == 3) {
                    const created = new Date(selectedCreatedDate);
                    const exp = new Date(this.forms.validity.expiresAt);

                    if (exp && exp.getTime() > created.getTime()) {
                        this.license.expires_at.value = this.forms.validity.expiresAt;
                        this.license.created_at.value = selectedCreatedDate;
                    }

                    if (!exp || exp.getTime() <= created.getTime()) {
                        this.license.expires_at.value = null;
                        this.license.created_at.value = null;
                    }
                }
            }
        },
        parseDate: function (date, years, months, days) {
            if (!date) {
                return null;
            }

            const dateString = `${date.getFullYear() + years}-${date.getMonth() + months}-${date.getDate() + days}`;
            return dateString.split('-').map((el) => {
                if (parseInt(el) < 10) {
                    return `0${el}`;
                }

                return el;
            }).join('-').trim();
        },
        onChangeExp: function (e) {
            const selectedExp = e.target.value;

            if (!selectedExp) {
                this.license.expires_at.value = null;
            }

            if (selectedExp) {
                const created = new Date(this.forms.validity.createdLicense);
                const exp = new Date(selectedExp);

                if (created && created.getTime() < exp.getTime()) {
                    this.license.expires_at.value = selectedExp;
                }

                if (!created || created.getTime() > exp.getTime()) {
                    this.license.expires_at.value = null;
                    this.forms.validity.expiresAt.value = null;
                }
            }
        },
        onChangeValidity: function (e) {
            const today = new Date()

            const selectedPeriod = e.target.value;

            this.forms.validity.createdLicense = selectedPeriod == 1 ? this.parseDate(today, 0, 1, 0) : this.forms.validity.createdLicense;
            this.forms.validity.createdLicense = selectedPeriod == 2 ? this.parseDate(today, 0, 1, 0) : this.forms.validity.createdLicense;
            this.forms.validity.createdLicense = selectedPeriod == 3 ? this.parseDate(today, 0, 1, 0) : this.forms.validity.createdLicense;

            this.forms.validity.expiresAt = selectedPeriod == 1 ? this.parseDate(today, 1, 1, 0) : this.forms.validity.expiresAt;
            this.forms.validity.expiresAt = selectedPeriod == 2 ? this.parseDate(today, 20, 1, 0) : this.forms.validity.expiresAt;
            this.forms.validity.expiresAt = selectedPeriod == 3 ? null : this.forms.validity.expiresAt;

            this.license.expires_at.value = this.forms.validity.expiresAt;
            this.license.created_at.value = this.forms.validity.createdLicense;
            this.license.type.value = selectedPeriod;
        },
        onSearchDevices: async function () {
            await this.getDevices();
        },
        getDevices: async function () {
            const data = await axios.get('/organizational/devices/list', {
                params: {
                    search: this.forms.searchingDevices.searchingControl,
                    limit: 50,
                    page: 1
                }
            }).then(resp => {
                return resp.data
            }).catch(_ => {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Не удалось получить список устройств, что-то пошло не так' });
            });

            if (data.status == 'ok') {
                this.forms.searchingDevices.devices = data.items;
            }

            if (data.status != 'ok') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: data.message });
            }
        },
        onCancelSearchDevices: async function () {
            if (this.forms.searchingDevices.searchingControl.trim() == '') {
                await this.getDevices();
            }
        },
        selectDevice: function (device) {
            this.forms.searchingDevices.selectedItem = device;
            this.forms.searchingDevices.openDropDown = false;
            this.forms.searchingDevices.payPerMounth = device.pay_per_month;

            this.license.device_id.value = this.forms.searchingDevices.selectedItem.id;
            this.license.pay_per_month.value = this.forms.searchingDevices.payPerMounth;
        },
        closeDropDown: function () {
            this.forms.searchingDevices.openDropDown = false;
        },
        openDropDown: async function () {
            await this.getDevices();
            this.forms.searchingDevices.openDropDown = true;
        },
        copyUuid: async function () {
            if (navigator && navigator.clipboard && navigator.clipboard.writeText) {
                await navigator.clipboard.writeText(this.modals.infoForCreatedLicense.uuid);
                window.location.href = '/documents/licenses';
            }
        },
        onCreateLicense: async function () {
            for (const prop in this.license) {
                if (!this.license[prop].value) {
                    console.log(this.license[prop])
                    this.addAlert({ type: 'info', title: 'Уведомление', text: this.license[prop].desc });
                    return;
                }
            }

            const data = await axios.post('/documents/licenses/create', {
                'created_at': this.license.created_at.value,
                'device_id': this.license.device_id.value,
                'expires_at': this.license.expires_at.value,
                'pay_per_month': this.license.pay_per_month.value,
                'status_payment': this.license.status_payment.value,
                'type': this.license.type.value,
                'contract_id': this.license.contract_id.value
            }).then(resp => {
                return resp.data
            }).catch(_ => {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Не удалось создать лицензию, что-то пошло не так' });
            });

            if (data.status == 'ok') {
                this.modals.infoForCreatedLicense.uuid = data.uuid;
                this.modals.infoForCreatedLicense.isOpen = true;
            }

            if (data.status != 'ok') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: data.message });
            }
        },
        closeModal: function () {
            this.forms = {
                searchingDevices: {
                    openDropDown: false,
                    devices: [],
                    selectedItem: null,
                    searchingControl: null,
                    payPerMounth: null
                },
                searchingContracts: {
                    openDropDown: false,
                    items: [],
                    selectedItem: null,
                    searchingControl: null,
                    payPerMounth: null
                },
                validity: {
                    selected: null,
                    createdLicense: null,
                    expiresAt: null
                },
                statusPay: {
                    selected: null
                },
            };

            this.license = this.licenseFish();

            this.modals.infoForCreatedLicense = {
                uuid: null,
                isOpen: false,
                isNavigator: navigator && navigator.clipboard && navigator.clipboard.writeText
            };

            window.location.reload();
        },
        getContracts: async function () {
            const resp = await axios.get('/documents/contracts/list', {
                params: {
                    page: 1,
                    limit: 60,
                    search: this.forms.searchingContracts.searchingControl
                }
            }).catch(res => {
                this.addAlert({ type: 'error', title: 'Ошибка', text: 'Не удалось получить список договоров, что-то пошло не так' });
            });

            if (resp.data.status != 'ok') {
                this.addAlert({ type: 'error', title: 'Ошибка', text: resp.data.message });
            }

            if (resp.data.status == 'ok') {
                this.forms.searchingContracts.items = resp.data.items;
            }
        },
        selectContracts: function (contract) {
            this.forms.searchingContracts.selectedItem = contract;
            this.forms.searchingContracts.openDropDown = false;
            this.license.contract_id.value = contract.contract_id;
        },
        closeDropDownSearchingContracts: function () {
            this.forms.searchingContracts.openDropDown = false;
        },
        openDropDownSearchingContracts: async function () {
            await this.getContracts();
            this.forms.searchingContracts.openDropDown = true;
        },
        onSearchContracts: async function () {
            await this.getContracts();
        },
        onCancelSearchContracts: async function () {
            if (this.forms.searchingContracts.searchingControl.trim() == '') {
                await this.getContracts();
            }
        },
    },
    mounted () {

    }
}
</script>

<style scoped>
.app-dropdown {
    border-radius: 5px;
    position: relative;
}

.app-dropdown .manager {
    border: 1px solid #ddd;
    border-radius: 4px;
}

.app-dropdown .items-block {
    position: relative;
    height: 200px;
    overflow: auto;
    z-index: 9999;
    background-color: #fff;
    border-bottom: 1px solid #ddd;
    border-left: 1px solid #ddd;
    border-right: 1px solid #ddd;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;
}

.app-dropdown .items-block .searching-block {
    position: sticky;
    top: 0;
    background-color: #fff;
}

.app-dropdown .items-block .searching-block input {
    border-bottom: 1px solid #ddd;
    border-top: none;
    border-radius: 0;
    border-left: none;
    border-right: none;
}

.app-dropdown .items {
    position: absolute;
    width: 100%;
}

.app-dropdown .items .item {
    padding: 0 10px;
    cursor: pointer;
    font-size: 16px;
}

.app-dropdown .items .item:hover {
    background-color: #3c7af0;
    color: white;
}

.app-dropdown .hidden {
    display: none;
}

.app-dropdown .manager {
    padding: 15px;
    height: 40px;
    cursor: pointer;
}

.app-dropdown .manager .button {
    background-image: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA0AAAAICAYAAAAiJnXPAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACeSURBVHgBjZDBDcMgDEVtqwN0hK7QETpCb8ClZYNkhG6QbtAb147ABs0G7Qg5coJ+okSKEFJAQthf/9nG7Jy7E9GJGo+IfA94PTN/8B4bmCnGeBat9S+ldG0ACIDNfskJAg+h32F6Y8x7HnFVIAzo+Ki5s66UGtacSwMW88Ifb5uRnijYbT1SQiGEDpXHpcNYAlXIWjsBvCD0uNUF/QEMBD/7Z34xowAAAABJRU5ErkJggg==");
    background-repeat: no-repeat;
    background-position: center right;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    font-size: 16px;
}

.app-dropdown .shade {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    z-index: 999;
    min-height: 100vh;
    overflow: hidden;
}

.app-dropdown .content {
    position: absolute;
    width: 100%;
    height: 200px;
}

.app-dropdown .disable {
    background-color: #ddd;
    cursor: initial;
}
</style>
